<svg width="40" height="30" viewBox="0 0 40 30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M16.8.55 9.847 7.5H1.875C.839 7.5 0 8.339 0 9.375v11.25C0 21.66.84 22.5 1.875 22.5h7.973l6.951 6.95c1.174 1.173 3.2.348 3.2-1.327V1.876C20 .2 17.973-.622 16.8.55zM36.064 15l3.566-3.566a1.26 1.26 0 0 0 0-1.783L37.848 7.87a1.26 1.26 0 0 0-1.783 0L32.5 11.434 28.934 7.87a1.26 1.26 0 0 0-1.783 0L25.37 9.65a1.26 1.26 0 0 0 0 1.783L28.934 15l-3.565 3.565a1.26 1.26 0 0 0 0 1.783l1.783 1.782a1.26 1.26 0 0 0 1.783 0l3.565-3.565 3.565 3.566a1.26 1.26 0 0 0 1.783 0l1.783-1.783a1.26 1.26 0 0 0 0-1.783L36.065 15z" id="g24siqv8la"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="ebd0neynmb" fill="#fff">
            <use xlink:href="#g24siqv8la"/>
        </mask>
        <use fill="#FFF" fill-rule="nonzero" xlink:href="#g24siqv8la"/>
        <g mask="url(#ebd0neynmb)" fill="currentColor">
            <path d="M0 0h40v30H0z"/>
        </g>
    </g>
</svg>
